<template>
    <v-form-element v-bind="$props">
        <v-multiselect
            :options="options"
            :track-by="trackBy"
            :multiple="true"
            :close-on-select="closeOnSelect"
            v-model="model"
            :placeholder="getPlaceholder()"
            :label="optionLabel"
            :select-label="selectLabel"
            :deselect-label="deselectLabel"
            :selected-label="selectedLabel"
            :limit-text="reachedLimit"
            open-direction="bottom"
        >
            <template slot="noResult">{{ $t('form.labels.multiselect.noResult') }}</template>
            <template slot="noOptions">{{ $t('form.labels.multiselect.emptyOptions') }}</template>
        </v-multiselect>
    </v-form-element>
</template>

<script>

    import VMultiselect from 'vue-multiselect'
    import VFormElement from './Element';
    import mixin from './mixin';

    export default {
        components: {
            VFormElement,
            VMultiselect,
        },
        data() {
            return {
                
            }
        },
        props: {
            options: {
                type: Array,
                required: true,
            },
            trackBy: {
                type: String,
                required: false,
                default: 'id',
            },
            closeOnSelect: {
                required: false,
                type: Boolean,
                default() {
                    return false;
                }
            },
            optionLabel: {
                required: false,
                type: String,
                default: 'title',
            },
            selectLabel: {
                required: false,
                type: String,
                default()
                {
                    return this.$t('form.labels.multiselect.select');
                }
            },
            deselectLabel: {
                required: false,
                type: String,
                default()
                {
                    return this.$t('form.labels.multiselect.deselect');
                }
            },
            selectedLabel: {
                required: false,
                type: String,
                default()
                {
                    return this.$t('form.labels.multiselect.selected');
                }
            },
            reachedLimit: {
                required: false,
                type: Function,
                default()
                {
                    return (count) => this.$t('form.labels.multiselect.limit', {count});
                }
            }
        },
        mixins: [mixin],
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
    .multiselect {
        .multiselect__tags {
            @apply w-full text-black placeholder-gray-500 font-thin px-3 pt-3 rounded border border-gray-300 bg-white outline-none hover:border-gray-600 focus:border-primary max-w-input text-sm    
        }
        .multiselect__tag {
            @apply bg-primary;
        }
        .multiselect__option--highlight:not(.multiselect__option--selected) {
            @apply bg-primary;
            &:after {
                @apply bg-primary;
            }
        }
        .multiselect__tag-icon {
            @apply text-white;
            &:after {
                @apply text-white;
            }
            &:focus, &:hover {
                @apply bg-primary-dark;
            }
        }
    }
</style>